module.exports = __webpack_public_path__ + "static/media/icn-plus.50d508f2.svg";